export default __webpack_public_path__ + "static/media/technological.68d151a4.png";